<template>
  <div>
    <a-tabs @change="getList" type="card">
      <a-tab-pane key="1" tab="违禁词">
        <ContrabandWord ref="contrabandWord" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="违禁词分类">
        <WordType />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ContrabandWord from './ContrabandWord/index'
import WordType from './WordType/index'

export default {
  name: '',
  components: {
    ContrabandWord,
    WordType
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    getList(key) {
      if (parseInt(key) === 1) {
        this.$refs.contrabandWord.getList()
        this.$refs.contrabandWord.getWordType()
      }
    }
  }
}
</script>

<style scoped>
</style>
